import { render, staticRenderFns } from "./ModalEditarProcedimento.vue?vue&type=template&id=150307da&scoped=true"
import script from "./ModalEditarProcedimento.vue?vue&type=script&lang=js"
export * from "./ModalEditarProcedimento.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarProcedimento.vue?vue&type=style&index=0&id=150307da&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150307da",
  null
  
)

export default component.exports